import Spinner from './Spinner'

interface LoadingScreenProps {
  title?: string
  description?: string
}
export default function LoadingScreen({ title, description }: LoadingScreenProps) {
  return (
    <div className='flex flex-col items-center mx-auto py-56'>
      <Spinner />
      <h1 className='text-xl font-serif text-white mt-8 mb-4'>{title}</h1>
      <p className='text-white'>{description}</p>
    </div>
  )
}
